import React, { HTMLAttributes, memo, ReactElement, ReactNode } from 'react'

import { Icon, IconName } from '../Icon'
import { Text } from '../Text'
import * as Styled from './styles'
import { BadgeSize } from './types/badgeSize'
import { BadgeType } from './types/badgeType'
import { BadgeColor, BadgeMode } from './types/colorStyles'
import { getColorStyles } from './utils/getColorStyles'
import { getDisabledStyles } from './utils/getDisabledStyles'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  children?: ReactNode
  color?: BadgeColor
  disabled?: boolean
  icon?: IconName
  mode?: BadgeMode
  onColor?: boolean
  size?: BadgeSize
  type?: BadgeType
}

export const Badge = memo(
  ({
    children,
    color = 'neutral',
    disabled = false,
    icon,
    mode = 'primary',
    onColor = false,
    size = 'md',
    type = 'default',
    ...rest
  }: BadgeProps): ReactElement => {
    const styles = disabled ? getDisabledStyles(mode, onColor) : getColorStyles(color, mode, onColor)
    const isLarge = type === 'default' && String(children).length > 1

    return (
      <Styled.BadgeWrapper
        badgeSize={size}
        badgeType={type}
        bgColor={styles.bgColor}
        clickable={!!rest.onClick}
        isLarge={isLarge}
        {...rest}
      >
        {type !== 'dot' && type !== 'icon' && (
          <Text as="span" variant={size === 'lg' ? 'bodyLG' : 'bodyMD'} weight="medium" color={styles.textColor}>
            {children}
          </Text>
        )}
        {type === 'icon' && icon && <Icon icon={icon} color={styles.textColor} size={size === 'lg' ? 'sm' : 'xs'} />}
      </Styled.BadgeWrapper>
    )
  },
)
